<script setup>
import { useForm, Link } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import { ref, onMounted } from "vue";
import FlatPickr from 'vue-flatpickr-component';
import Loading from 'vue-loading-overlay';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

const props = defineProps({
    year: String,
    flash: Object,
    user: Object,
    bookings: Object,
    agents: Object,
    hotels: Object,
});

let isLoading = ref(false);
dayjs.extend(advancedFormat);
const urlParams = new URLSearchParams(window.location.search);

const configFrom = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});
const configTo = ref({
    altFormat: 'J M, Y',
    altInput: true,
    dateFormat: 'Y-m-d',
});

function handleDeptDateChange() {
    configTo.value = {
        ...configTo.value,
        minDate: productionForm.checkinFrom
    };
}
//set the productionForm data to rhe selected data

onMounted(() => {
    if (props.bookings) {
        productionForm.checkinFrom = urlParams.get('checkinFrom');
        productionForm.checkinTo = urlParams.get('checkinTo');
        productionForm.agent_filter = urlParams.get('agent_filter');
        productionForm.hotel_filter = urlParams.get('hotel_filter');
        productionForm.status_filter = urlParams.get('status_filter');
    }
});

const productionForm = useForm({
    checkinFrom: '',
    checkinTo: '',
    agent_filter: 'all',
    hotel_filter: 'all',
    status_filter: 'all',
});

const bookingsformSubmit = () => {
    productionForm.get('/reports/searchBookings', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
    });
};

//function to calculate total number of nights. when given booking_rooms object loop throught it to get nights
function getTotalNights(booking_rooms) {
    let totalNights = 0;
    booking_rooms.forEach(booking_room => {
        totalNights += booking_room.nights;
    });
    return totalNights;
}

function getTotalNightsFromProps() {
    let totalnumberofnights = 0;
    props.bookings?.forEach(booking => {
        totalnumberofnights += getTotalNights(booking.booking_rooms) * (booking.no_rooms);
    });
    return parseInt(totalnumberofnights);
}

//function to call excel export url
function exportExcel() {
    window.location.href = '/reports/exportBookingsReportExcel?checkinFrom=' + productionForm.checkinFrom + '&checkinTo=' + productionForm.checkinTo + '&agent_filter=' + productionForm.agent_filter + '&hotel_filter=' + productionForm.hotel_filter + '&status_filter=' + productionForm.status_filter;
}

function exportPdf() {
    window.location.href = '/reports/exportBookingsReportPdf?checkinFrom=' + productionForm.checkinFrom + '&checkinTo=' + productionForm.checkinTo + '&agent_filter=' + productionForm.agent_filter + '&hotel_filter=' + productionForm.hotel_filter + '&status_filter=' + productionForm.status_filter;
}

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import 'flatpickr/dist/themes/material_orange.css';
@import "vue-loading-overlay/dist/vue-loading.css";
</style>
<template>
    <AppLayout title="Bookings Report" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-fluid flex-grow-1 container-p-y">
            <div class="card">
                <div class="card-header border-bottom">
                    <h5 class="card-title">Bookings Report</h5>
                    <div class="row mx-2">
                        <div class="col-sm-12 col-md-4 col-lg-8"></div>
                        <div class="col-sm-12 col-md-12 col-lg-12">
                            <form @submit.prevent="bookingsformSubmit">
                                <div class="text-start d-flex">
                                    <div class="pb-sm-0 m-2">
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <label>
                                                <FlatPickr v-model="productionForm.checkinFrom" :config="configFrom"
                                                    class="form-control" placeholder="Bookings From.." name="checkinFrom"
                                                    @change="handleDeptDateChange" />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="pb-sm-0 m-2">
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <label>
                                                <FlatPickr v-model="productionForm.checkinTo" :config="configTo"
                                                    class="form-control" placeholder="Bookings To.." name="checkinTo" />
                                            </label>
                                        </div>
                                    </div>
                                    <div class="pb-sm-0 m-2">
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <label>
                                                <select class="form-select text-capitalize"
                                                    v-model="productionForm.agent_filter" name="agent_filter">
                                                    <option value="0" disabled="disabled"> Filter by
                                                        Agent
                                                    </option>
                                                    <option value="all">All</option>
                                                    <option v-for="agent in agents" :value="agent.id">
                                                        {{ agent.agency_name }}
                                                    </option>
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="pb-sm-0 m-2">
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <label>
                                                <select id="search" class="form-select text-capitalize"
                                                    v-model="productionForm.hotel_filter" name="hotel_filter">
                                                    <option value="0" disabled="disabled"> Filter by
                                                        Hotel
                                                    </option>
                                                    <option value="all">All</option>
                                                    <option v-for="hotel in hotels" :value="hotel.id">
                                                        {{ hotel.name }}
                                                    </option>
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="pb-sm-0 m-2">
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <label>
                                                <select id="search" class="form-select text-capitalize"
                                                    v-model="productionForm.status_filter" name="status_filter" required>
                                                    <option value="0" disabled="disabled"> Filter by
                                                        Status
                                                    </option>
                                                    <option value="all">All</option>
                                                    <option value="Pending">Pending</option>
                                                    <option value="Confirmed">Confirmed</option>
                                                    <option value="Cancelled">Cancelled</option>
                                                    <option value="Paid">Paid</option>
                                                </select>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="pb-sm-0 m-2">
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <button type="submit" class="btn btn-primary">Generate</button>
                                        </div>
                                    </div>
                                    <div class="pb-sm-0 m-2">
                                        <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                            <div class="dt-action-buttons">
                                                <div class="btn-group">
                                                    <button type="button" class="btn btn-label-info dropdown-toggle"
                                                        data-bs-toggle="dropdown" aria-expanded="false"><i
                                                            class="bx bx-export me-sm-2"></i>
                                                        Export
                                                    </button>
                                                    <ul class="dropdown-menu" style="">
                                                        <li>
                                                            <a class="dropdown-item" href="javascript:void(0);"
                                                                @click="exportExcel"><i class="bx bx-file me-2"></i>Excel
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a class="dropdown-item" href="javascript:void(0);"
                                                                @click="exportPdf"><i class="bx bxs-file-pdf me-2"></i>Pdf
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="card-datatable table-responsive">
                    <div id="DataTables_Table_0_wrapper" class="dataTables_wrapper dt-bootstrap5 no-footer">
                        <table class="datatables-basic table border-top dataTable no-footer dtr-column"
                            id="DataTables_Table_0" role="grid" aria-describedby="DataTables_Table_0_info"
                            style="width: 1390px;">
                            <thead>
                                <tr role="row">
                                    <th>Booking Ref</th>
                                    <th>Hotel Name</th>
                                    <th>Agency</th>
                                    <th>Arrival Date</th>
                                    <th>Departure Date</th>
                                    <th>No of Rooms</th>
                                    <th>No of Nights</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="odd" v-for="booking in bookings">
                                    <td>{{ booking.booking_no }}</td>
                                    <td>{{ booking.hotel?.name }}</td>
                                    <td>{{ booking.agent.agency_name }}</td>
                                    <td>{{ dayjs(booking.arrival_date).format('Do MMMM YYYY') }}</td>
                                    <td>{{ dayjs(booking.departure_date).format('Do MMMM YYYY') }}</td>
                                    <td>{{ booking.no_rooms }}</td>
                                    <td>{{ getTotalNights(booking.booking_rooms) * (booking.no_rooms) }}</td>
                                    <td>
                                        <span v-if="booking.status == 'Pending'" class="badge bg-label-dark">Pending</span>
                                        <span v-if="booking.status == 'SendConfirmation'"
                                            class="badge bg-label-warning">Send to Confirmation</span>
                                        <span v-if="booking.status == 'Confirmed'"
                                            class="badge bg-label-info">Confirmed</span>
                                        <span v-if="booking.status == 'Cancelled'"
                                            class="badge bg-label-danger">Cancelled</span>
                                        <span v-if="booking.status == 'Paid'" class="badge bg-label-success">Paid</span>
                                    </td>
                                    <td>
                                        <Link :href="'/bookings/show/' + booking.id" class="btn btn-icon btn-label-primary"
                                            preserve-state>
                                        <i class="bx bx-search-alt"></i>
                                        </Link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="datatables-basic table border-top dataTable no-footer dtr-column"
                            style="width: 1390px;">
                            <tr class="odd">
                                <td><b>
                                        Total Nights: {{ getTotalNightsFromProps() }}
                                    </b></td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>